import React from 'react'
import { Button } from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons'

export const ButtonCancel = props => (
  <Button {...props} variant='outline' colorScheme='red' leftIcon={<CloseIcon />}>
    Cancelar
  </Button>
)

export default ButtonCancel
